import { api } from "@/api/client";
import { RecordAttachment, ReferenceDocument } from "@/types";
import { UserSignature } from "@/api/user";

export enum RecordStandardGroup {
  ISO,
  ASME,
  AWSD1_1,
  DOT,
  API,
  AS,
  PED,
  AWSD17_1,
  WAPI,
}

export type RecordSignature = {
  recordId: string;
  signatureId?: string;
  title: string;
  signed: boolean;
};

export function getRecordSignatures(recordId: string) {
  return api.get<RecordSignature[]>(`record/${recordId}/signatures`);
}

export function signSignature(signature: RecordSignature, userSignature?: UserSignature) {
  return api.post(`record/sign/${signature.signatureId}`, {
    userSignatureId: userSignature?.userSignatureId,
  });
}

export function getRecordAttachments(recordId: string) {
  return api.get<RecordAttachment[]>(`record/${recordId}/attachments`);
}

export function getReferenceDocuments() {
  return api.get<ReferenceDocument[]>("references");
}
